/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CounselingDto } from '../../models/counseling-dto';
import { UpdateCounselingDto } from '../../models/update-counseling-dto';

export interface CounselingControllerUpdate$Params {
  counselingId: string;
      body: UpdateCounselingDto
}

export function counselingControllerUpdate(http: HttpClient, rootUrl: string, params: CounselingControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CounselingDto>> {
  const rb = new RequestBuilder(rootUrl, counselingControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('counselingId', params.counselingId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CounselingDto>;
    })
  );
}

counselingControllerUpdate.PATH = '/api/counseling/{counselingId}';
